import React, { useState, Component } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '¿Necesito comprar ingredientes caros o difíciles de conseguir?',
  answer: 'No. Todas las recetas están diseñadas con ingredientes sencillos que encuentras en cualquier supermercado o dietética local. Además, el Manual de Sustituciones te enseña cómo adaptar cualquier plato con lo que ya tienes en casa.'
}, {
  question: '¿Cuánto tiempo me tomará ver resultados reales?',
  answer: 'El programa está diseñado para que empieces a sentirte con menos hinchazón y más energía en menos de 7 días. La clave es que hagas tu planificación semanal.'
}, {
  question: '¿Es un plan de dieta estricto o pasaré hambre?',
  answer: 'Para nada. No es una dieta restrictiva, sino un cambio hacia una alimentación antiinflamatoria. Recibirás recetas de desayunos energéticos, platos principales y sopas reconfortantes que te mantendrán satisfecha.'
}, {
  question: '¿Cómo recibo el material una vez que realizo el pago?',
  answer: 'El acceso es inmediato. Una vez confirmado tu pago seguro, recibirás un correo electrónico con todos los archivos digitales (Ebooks, Guías y Planificadores) para que puedas empezar hoy mismo.'
}, {
  question: '¿Qué pasa si el programa no es lo que esperaba?',
  answer: 'Tu inversión está protegida. Ofrecemos una Garantía de Satisfacción de 7 Días. Si sientes que el contenido no es para ti, puedes solicitar la devolución de tu dinero sin complicaciones.'
}];
function FAQItemComponent({
  item,
  isOpen,
  onToggle
}: {
  item: FAQItem;
  isOpen: boolean;
  onToggle: () => void;
}) {
  return <div className="border-b border-wellness-darkBeige/30 last:border-b-0" data-id="element-39">
      <button onClick={onToggle} className="w-full flex items-center justify-between py-5 px-1 text-left group" data-id="element-40">
        <span className="font-semibold text-base md:text-lg pr-4 text-wellness-dark group-hover:text-wellness-primary transition-colors" data-id="element-41">
          {item.question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.25
      }} className="flex-shrink-0" data-id="element-42">
          <ChevronDownIcon className="w-5 h-5 text-wellness-primary" data-id="element-43" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-44">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-45">
            <p className="pb-5 px-1 text-wellness-body leading-relaxed" data-id="element-46">
              {item.answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-14 px-4 bg-white" data-id="element-47">
      <div className="max-w-3xl mx-auto" data-id="element-48">
        <div className="text-center mb-10" data-id="element-49">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-50">
            Preguntas Frecuentes
          </h2>
          <p className="text-lg text-wellness-body" data-id="element-51">
            Resolvemos tus dudas para que tomes la mejor decisión.
          </p>
        </div>

        <div className="bg-wellness-beige rounded-2xl p-6 md:p-8" data-id="element-52">
          {faqs.map((faq, i) => <FAQItemComponent key={i} item={faq} isOpen={openIndex === i} onToggle={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-53" />)}
        </div>
      </div>
    </section>;
}